import { supabase } from './supabaseClient.ts';
import { startScan } from './apiService.ts';
import { withTimeout } from '../utils/retryUtils.ts';

export async function handlePostLoginRedirect() {
  console.log('[authRedirect] Starting post-login redirect check');
  
  try {
    // Add timeout to session check
    const { data: { session } } = await withTimeout(
      supabase.auth.getSession(),
      10000, // 10 second timeout
      'Session check timed out'
    );
    
    if (!session) {
      console.log('[authRedirect] No session found, redirecting to upload');
      window.location.href = '/upload';
      return;
    }

    // Debug current localStorage state
    console.log('[authRedirect] Checking pending upload and signup source');
    console.log('[authRedirect] pendingUpload:', localStorage.getItem('pendingUpload'));
    console.log('[authRedirect] signupSource:', localStorage.getItem('signupSource'));

    // Step 1: Check for pending upload
    const uploadRaw = localStorage.getItem('pendingUpload');
    if (uploadRaw) {
      try {
        const pendingUpload = JSON.parse(uploadRaw);
        console.log('[authRedirect] Detected pending upload:', pendingUpload);
        
        // Circuit breaker: wrap startScan in timeout and catch all errors
        try {
          const scan = await withTimeout(
            startScan({ sourceType: pendingUpload.type, fileUrl: pendingUpload.fileUrl }),
            5000, // 5 second timeout for scan start
            'Scan start timed out'
          );
          
          if (!scan?.scan_id) {
            throw new Error('Invalid scan response - no scan ID');
          }
          
          localStorage.removeItem('pendingUpload');
          console.log('[authRedirect] Redirecting to scan:', scan.scan_id);
          window.location.href = `/results/${scan.scan_id}`;
          return;
          
        } catch (scanError) {
          console.error('[authRedirect] Scan start failed, falling back to upload:', scanError);
          // Circuit breaker: on any scan error, clean up and redirect to upload
          localStorage.removeItem('pendingUpload');
          window.location.href = '/upload';
          return;
        }
        
      } catch (parseError) {
        console.error('[authRedirect] Failed to parse pending upload:', parseError);
        // Clean up localStorage for JSON parse errors
        localStorage.removeItem('pendingUpload');
      }
    }

    // Step 2: If signup source is demo
    const source = localStorage.getItem('signupSource');
    if (source === 'demo') {
      const redirectTarget = '/demo-results';
      console.log('[authRedirect] Redirecting to:', redirectTarget);
      localStorage.removeItem('signupSource');
      window.location.href = redirectTarget;
      return;
    }

    // Fallback - always redirect to upload on any path
    const redirectTarget = '/upload';
    console.log('[authRedirect] Redirecting to:', redirectTarget, '(fallback)');
    window.location.href = redirectTarget;
    
  } catch (error) {
    console.error('[authRedirect] Critical error in redirect logic:', error);
    // Circuit breaker: on any error, immediately redirect to upload
    window.location.href = '/upload';
  }
}
